import { render, staticRenderFns } from "./denyRequestDialog.vue?vue&type=template&id=85108332&"
import script from "./denyRequestDialog.vue?vue&type=script&lang=js&"
export * from "./denyRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports